/** 2027 launch dates — one place to change them.
 *  TRIPS_LIVE: when 2027 trips go live (countdown on the homepage hero). Nov 4 2026,
 *  5:00 PM Mountain (MST; DST ends Nov 1). Leadership may still move this date
 *  (it has not been announced publicly yet, per the Oct 14 walkthrough). */
export const TRIPS_LIVE = "2026-11-04T17:00:00-07:00";

export const REGISTRATION_WEEK = "November 30 – December 4";

export const tripsLive = (now = Date.now()) => now >= Date.parse(TRIPS_LIVE);

/** HXP's Google Business profile (reviews). Rating and count were read off the Google
 *  profile on 2026-10-25 (1,697 of them five-star); refresh them here from time to time. The count is ALL reviews
 *  (not only five-star ones), so the copy says "Google reviews". */
export const GOOGLE_REVIEWS = "https://g.page/r/Cewp9aLUQIGJEBM";
export const GOOGLE_RATING = "5.0";
export const GOOGLE_REVIEW_COUNT = "1,724";

/** Registration week, one age group per day (pattern from the 2026 FAQ; BX to confirm). */
export const registrationDays = [
  { day: "Monday", date: "Nov 30", who: "Parent Builders & 19-year-olds" },
  { day: "Tuesday", date: "Dec 1", who: "18-year-olds" },
  { day: "Wednesday", date: "Dec 2", who: "17-year-olds" },
  { day: "Thursday", date: "Dec 3", who: "16-year-olds" },
  { day: "Friday", date: "Dec 4", who: "15- & 14-year-olds" },
];
